import { Navigate, Outlet } from 'react-router'
import { useSession } from '@/lib/session'
import { routes } from '@/routes'

/** Só passa quem tem token. Sem ele, a tela de entrada, com o motivo quando a sessão terminou (RN-POR-03). */
export function RequireSession() {
  const session = useSession()
  if (session.status === 'signed_out') {
    return (
      <Navigate to={session.reason === 'expired' ? routes.signInExpired : routes.signIn} replace />
    )
  }
  return <Outlet />
}
